import React, { type FC } from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Body, Flex } from "@edreamsodigeo/prisma-design-system";

const GoogleSeparator: FC = () => {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center" justifyContent="center">
      <Body color="neutral.80" type="base" weight="normal">
        {t("authentication.social.orwithemail")}
      </Body>
    </Flex>
  );
};

export default GoogleSeparator;
